var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    background: _vm.loading ? '#ffffff' : '#fbf7f3',
  })},[_c('van-skeleton',{staticClass:"guess-know",attrs:{"title":"","row":"0","loading":_vm.loading}},[_c('div',{staticClass:"guess-know-info"},_vm._l((_vm.characters),function(item,index){return _c('van-cell',{key:index,staticClass:"guess-know-name",attrs:{"center":"","title":item.role,"icon":item.roleImg,"is-link":"","url":`/characterDetail/${item.id}`}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }